import { AccountTypeEnum } from "../../graphql/supergraphTypes";
import { isJoinAccountType, isIndividualAccountType } from "../../utils/account_types";

export const getAccountTypeLabel = (accountType: AccountTypeEnum | undefined) => {
  if (isIndividualAccountType(accountType)) {
    return "Individual";
  }
  if (isJoinAccountType(accountType)) {
    return "Joint ownership account";
  }
  return "Institution";
};
